import { memo } from 'react';
import { cn } from '@/shared/utils/cn';
import type { FileUploaderFileFormat } from '../../types';
import apiUrl from '../../assets/icons/api.svg';
import csvUrl from '../../assets/icons/csv.svg';
import jpgUrl from '../../assets/icons/jpg.svg';
import mp4Url from '../../assets/icons/mp4.svg';
import pdfUrl from '../../assets/icons/pdf.svg';
import pngUrl from '../../assets/icons/png.svg';

export type FileTypeIconSize = 'sm' | 'md' | 'lg';

const FORMAT_ICON_SRC: Record<FileUploaderFileFormat, string> = {
  pdf: pdfUrl,
  csv: csvUrl,
  jpg: jpgUrl,
  png: pngUrl,
  mp4: mp4Url,
  api: apiUrl,
};

const SIZE_BOX: Record<FileTypeIconSize, string> = {
  sm: 'ui-h-[18px] ui-w-[18px]',
  md: 'ui-h-24 ui-w-24',
  lg: 'ui-h-32 ui-w-32',
};

export interface FileTypeIconProps {
  /** Tipo de archivo (artwork en `assets/icons/<format>.svg`). */
  format: FileUploaderFileFormat;
  /** Tamaño del bloque (Figma: 18 / 24 / 32). Los SVG de origen son 32×32. */
  size?: FileTypeIconSize;
  className?: string;
}

/**
 * Icono de tipo de archivo según Figma `_file types`.
 * Usa los vectores en `modules/FileUploader/assets/icons/*.svg` (documento + badge + etiqueta).
 */
export const FileTypeIcon = memo(function FileTypeIcon({
  format,
  size = 'lg',
  className,
}: FileTypeIconProps) {
  const src = FORMAT_ICON_SRC[format];

  return (
    <div className={cn('ui-relative ui-shrink-0', SIZE_BOX[size], className)}>
      <img
        src={src}
        alt=""
        aria-hidden
        draggable={false}
        className={cn(
          'ui-pointer-events-none ui-block ui-h-full ui-max-h-full ui-w-full ui-max-w-full ui-object-contain',
        )}
      />
    </div>
  );
});

FileTypeIcon.displayName = 'FileTypeIcon';
